import { Dialog, Grid } from "@material-ui/core";
import { connect } from 'react-redux'
import React from "react"
import CloseIcon from '@material-ui/icons/Close';
import { setSnackBar } from '../../models/application/applicationActions'
import DocumentUploadForm from "../forms/DocumentUploadForm";



const DocumentUploadDialog = (props) => {
    const { existing, onClose, tag, tags, onReload } = props
    return <div>
        
        <Dialog
            maxWidth='md'
            style={{ padding: 20, minWidth: 800 }}
            open={props.onOpen} onClose={onClose} aria-labelledby="form-dialog-title" disableBackdropClick={true}>
            <div style={{ position: 'absolute', right: 10, top: 10 }}>
                <CloseIcon
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        onClose(false)
                    }} />
            </div>
            
                
                <div style={{ paddingTop: 20, paddingLeft: 20, paddingBottom: 0 }}>  ატვირთე ახალი დოკუმენტი</div>
                <DocumentUploadForm tags={tags} tag={tag} onReload={onReload} onClose={onClose}/>  
            
        </Dialog>
    </div>
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.auth,
        app: state.app
    }
}

export default connect(mapStateToProps, { setSnackBar })(DocumentUploadDialog)